package com.eladfinish.bible.contest.extensions

import androidx.compose.ui.text.TextRange
import com.eladfinish.bible.contest.constants.ColorConstants.HIGHLIGHT
import com.eladfinish.bible.contest.text.SpanType
import com.eladfinish.bible.contest.text.SpannableStringKMP
import com.eladfinish.bible.contest.text.SpannedRange
import com.eladfinish.bible.contest.utils.RegexUtils
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList

const val FONT_SERIF = "serif"

fun CharSequence.makeContinuousUnderlinedKMP(): SpannableStringKMP {
    return SpannableStringKMP(charSequence = this, spannedRangeList = persistentListOf())
        .makeContinuousUnderlinedKMP()
}

fun SpannableStringKMP.makeContinuousUnderlinedKMP(): SpannableStringKMP {
    val list = mutableListOf<SpannedRange>()
    RegexUtils.UNDERSCORES.toRegex().findAll(this.charSequence).forEach {
        list.add(SpannedRange(SpanType.CustomTypeface(FONT_SERIF), TextRange(start = it.start, end = it.end)))
    }
    return SpannableStringKMP(
        charSequence = this.charSequence,
        spannedRangeList = (this.spannedRangeList + list).toImmutableList(),
    )
}

fun List<SpannedRange>.makeContinuousUnderlinedKMP(charSequence: CharSequence): List<SpannedRange> =
    this.plus(RegexUtils.UNDERSCORES.toRegex().findAll(charSequence).map {
        SpannedRange(SpanType.CustomTypeface(FONT_SERIF), TextRange(start = it.start, end = it.end))
    })

fun highlightTextSpannedRange(start: Int, end: Int): SpannedRange =
    SpannedRange(
        spanType = SpanType.BackgroundColor(color = HIGHLIGHT),
        textRange = TextRange(start = start, end = end),
    )
